import { PDFDocument } from 'pdf-lib';
import { generateZugferdXml, type ZugferdParams } from '../pe-papers/zugferdGenerator';

function uint8ToDataUri(bytes: Uint8Array): string {
  let binary = '';
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunk));
  }
  return `data:application/pdf;base64,${btoa(binary)}`;
}

/** Hängt ZUGFeRD/Factur-X XML an ein bestehendes PDF (z. B. html2canvas-Export). */
export async function attachZugferdToPdfBytes(
  pdfBytes: ArrayBuffer | Uint8Array,
  zugferdParams: ZugferdParams
): Promise<{ pdfBytes: Uint8Array; base64PDF: string }> {
  const xmlContent = generateZugferdXml(zugferdParams);
  const xmlBytes = new TextEncoder().encode(xmlContent);
  const pdfDoc = await PDFDocument.load(pdfBytes);
  await pdfDoc.attach(xmlBytes, 'factur-x.xml', {
    mimeType: 'text/xml',
    description: 'Factur-X / ZUGFeRD 2.1 Invoice XML',
    creationDate: new Date(),
    modificationDate: new Date(),
  });
  const hybridBytes = new Uint8Array(await pdfDoc.save());
  return { pdfBytes: hybridBytes, base64PDF: uint8ToDataUri(hybridBytes) };
}

export function triggerPdfBytesDownload(bytes: Uint8Array, fileName: string): void {
  const blob = new Blob([bytes], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
